import { CRUDMutations } from '@/utils/store-utilities'

const defaultItem = (item) => ({
  ...item,
})

export const state = () => ({
  items: [],
})

export const mutations = {
  ...CRUDMutations(defaultItem),
}

export const getters = {}

export const actions = {
  createCoupon({ commit }, item) {
    return this.$axios.$post('admin/coupons/create', { ...item }).then((response) => {
      commit('add', { ...response.data })
    })
  },
  removeCoupon({ commit }, item) {
    return this.$axios.$delete(`admin/coupons/${item.id}`).then((response) => {
      if (response.data) {
        commit('remove', item)
      }
    })
  },
  updateCoupon({ commit }, item) {
    return this.$axios.$put(`admin/coupons/${item.id}`, { ...item }).then((response) => {
      commit('update', { ...response.data })
    })
  },
  fetchCoupons({ commit }) {
    return this.$axios.$get('admin/coupons').then((response) => {
      commit('load', response.data)
    })
  },
  fetchCoupon({ commit }, id) {
    return this.$axios.$get(`admin/coupons/${id}`).then((response) => {
      return response.data
    })
  },
}
